import { BrowserRouter, Routes, Route } from "react-router-dom";
import STYLES from "./styles";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import Experience from "./pages/Experience";
import Gallery from "./pages/Gallery";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import LeaveReview from "./pages/LeaveReview";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";

export default function App() {
  return (
    <BrowserRouter>
      <CookieBanner>
        <style>{STYLES}</style>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/leave-review" element={<LeaveReview />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
        <WhatsAppWidget />
        <Footer />
      </CookieBanner>
    </BrowserRouter>
  );
}
